import { isValidElement } from 'react';
import _isString from 'lodash/isString';
import _isNumber from 'lodash/isNumber';
import _truncate from 'lodash/truncate';
import _reduce from 'lodash/reduce';
import { SelectOption } from '@minecraft.typings';

type GetSelectionsResultArgs = {
  isMultipleSelect: boolean;
  maxSelectionsResultLength?: number;
  selectedOptions: SelectOption[];
};

export const getSelectionsResult = ({
  isMultipleSelect,
  maxSelectionsResultLength,
  selectedOptions,
}: GetSelectionsResultArgs): string | JSX.Element => {
  if (_isString(selectedOptions?.[0]?.label) || _isNumber(selectedOptions?.[0]?.label)) {
    if (selectedOptions.length === 1) {
      const selectionsResult = String(selectedOptions[0].label) || '';

      return maxSelectionsResultLength
        ? _truncate(selectionsResult, {
            length: maxSelectionsResultLength,
            separator: '...',
          })
        : selectionsResult;
    }

    if (selectedOptions.length > 1) {
      return `${selectedOptions.length} Selected`;
    }

    return '';
  }

  if (!isMultipleSelect && isValidElement(selectedOptions?.[0]?.label)) {
    return selectedOptions?.[0]?.label;
  }

  return '';
};

export const getCleanOptions = (options: SelectOption[]): SelectOption[] => {
  return _reduce(
    options,
    (acc, option) => {
      if ((!option?.label || !option?.value) && option?.options?.length > 0) {
        return [...acc, ...option.options];
      }

      return [...acc, option];
    },
    []
  );
};
